/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export const toShortNum = (num: number | null | undefined): string => {
	if (num === null || num === undefined) return "";
	return num > 1000
		? Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(num)
		: num.toString();
};
